module.exports = __webpack_public_path__ + "img/PSLRLOCClock.4ba3d6ef.svg";